<canvas [id]="chartName">{{ chart }}</canvas>
